import React, { useState } from "react";
import "./footerDisclaimers.scss";
import upArrow from "../../assets/images/arrows/ic_chevron_accordian_up.svg";
import downArrow from "../../assets/images/arrows/ic_chevron_accordian_down.svg";
import { DOCS_BASE_PATH } from "../../constants/externalLinks";

const disclaimerLinks = {
  title: "",
  listType: "disclaimer-links",
  links: [
    {
      title: "Disclaimer and Terms & Conditions",
      link: "/terms-conditions",
    },
    {
      title: "Policy & Procedure",
      link: "/policies-procedures",
    },
    {
      title: "Privacy Policy",
      link: "https://www.phonepe.com/privacy-policy/",
      target: "_blank",
    },
    {
      title: "Bank Details",
      link: "/bank-details",
    },
    // {
    //   title: 'Risk Management System Policy',
    //   link: '/risk-management-policy',
    // },
    {
      title: "KYC Documents in Vernacular languages",
      link:
        "https://www.nseindia.com/trade/members-client-registration-documents",
      target: "_blank",
    },
    // {
    //   title: 'Stay Secure',
    //   link: '#',
    // },
    {
      title: "Stay Alert",
      link: "/stay-alert",
    },
    {
      title:
        "Attention - A note from the Regulators for Investors",
      link: "/attention-note-regulator-investor",
    },
    {
      title: "KYC (Trading + DP account)",
      link: `${DOCS_BASE_PATH}/KYC_Trading_DP_Account.pdf`,
      target: "_blank",
    },
    {
      title: "Standard Documents for KYC",
      link: `${DOCS_BASE_PATH}/Standard_Documents_For_KYC.pdf`,
      target: "_blank",
    },
    {
      title: "Modification Form",
      link: `${DOCS_BASE_PATH}/Account_Modification_Form.pdf`,
      target: "_blank",
    },
    {
      title: "Contact Us",
      link: "/contact-us",
    },
    // {
    //   title: 'Inactive Account Policy',
    //   link: '/inactive-account-policy',
    // },
    {
      title: "E-Voting",
      link: "https://www.evotingindia.com/",
      target: "_blank",
    },
    {
      title: "List of Charges",
      link: "/charges",
    },
    {
      title: "AML & CFT - Investor Education",
      link: "/aml-cft-investor-education",
    },
    {
      title: "Disclosure",
      link: "/disclosure",
    },
    {
      title: "Scores and Smart ODR",
      link: "/scores-and-smart-odr",
    },
    {
      title: "Other Regulatory Circulars",
      link: "/other-regulatory-circulars",
    },
    {
      title: "Steps for Opening an Account",
      link:
        "/support/home/getting-started/creating-a-trading-and-demat-account/how-do-i-open-a-trading-and-demat-account-on-phonepe-broking/",
      target: "_blank",
    },
    {
      title:
        "Flow Chart for Complaint Raising and Tracking",
      link: "/flow-chart-for-complaint-raising-tracking",
    },
    {
      title: "Investor Risk Reduction Access",
      link: "/investor-risk-reduction-access",
    },
  ],
};

const marketTypes = {
  title: "Important Links: ",
  listType: "disclaimer-links",
  links: [
    {
      title: "BSE",
      link: "https://www.bseindia.com/",
      target: "_blank",
    },
    {
      title: "NSE",
      link: "https://www.nseindia.com/",
      target: "_blank",
    },
    {
      title: "SEBI",
      link: "https://www.sebi.gov.in/",
      target: "_blank",
    },
    {
      title: "CDSL",
      link: "https://www.cdslindia.com/index.html",
      target: "_blank",
    },
  ],
};

const investorCharter = {
  title: "Investor Charter: ",
  listType: "disclaimer-links",
  links: [
    {
      title: "Stock Broker",
      link: `${DOCS_BASE_PATH}/Investor_Charter_For_Stock_Brokers.pdf`,
      target: "_blank",
    },
    {
      title: "Depository Participant CDSL",
      link: `${DOCS_BASE_PATH}/Investor_Charter_For_Depository_Participant_CDSL.pdf`,
      target: "_blank",
    },
  ],
};

const disclousers = {
  title: "Monthly Complaints Disclosure: ",
  listType: "disclaimer-links",
  links: [
    {
      title: "Stock Broker",
      link: `${DOCS_BASE_PATH}/Monthy_Complaint_Stock_Broker.pdf`,
      target: "_blank",
    },
    {
      title: "Depository Participant",
      link: `${DOCS_BASE_PATH}/Monthly_Complaint_DP.pdf`,
      target: "_blank",
    },
  ],
};

const disclaimers = [
  disclaimerLinks,
  marketTypes,
  investorCharter,
  disclousers,
];

const phonepeWealth =
  "PhonePe Wealth Broking Private Limited - SEBI Regn. No.: BSE / NSE : INZ000302639";

const memberId =
  "Member id : BSE - 6756 NSE 90226. Depository services through: CDSL - IN-DP-696-2022. Mutual Fund: ARN 187821. Research Analyst – INH000013387.";

const complianceOfficers =
  "Compliance Officer: Shrenik Shah; Email ID: co@share.market; Tel:080-68727689 . For any complaints email at grievances@share.market";

const riskDisclaimer =
  "Investments in securities market are subject to market risks, read all the related documents carefully before investing.";

const investorDisclaimers =
  "Attention investors:1) Message from Exchange(s): Prevent Unauthorised transactions in your account --> Update your mobile numbers/email IDs with your stock brokers. Receive information of your transactions directly from Exchange on your mobile/email at the end of the day. Issued in the interest of investors. 2) Message from Depositories: a) Prevent Unauthorized Transactions in your demat account --> Update your mobile number with your Depository Participant. Receive alerts on your registered mobile for all debit and other important transactions in your demat account directly from NSDL / CDSL on the same day issued in the interest of investors. b) KYC is one time exercise while dealing in securities markets - once KYC is done through a SEBI registered intermediary (broker, DP, Mutual Fund etc.), you need not undergo the same process again when you approach another intermediary. 3) No need to issue cheques by investors while subscribing to IPO. Just write the bank account number and sign in the application form to authorise your bank to make payment in case of allotment. No worries for refund as the money remains in investor's account. 4) Registration granted by SEBI and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors.";

const compnayIdNumber =
  "Company Identification Number (CIN): U65990KA2021PTC146954";

const FooterDisclaimers = () => {
  const accordionState = false;
  const [accordionOpen, setAccordionOpen] = useState(
    accordionState
  );
  const toggleAccordion = e => {
    const sibling =
      e.target.parentElement.nextElementSibling ||
      e.target.parentElement.parentElement
        .nextElementSibling;
    if (sibling) {
      if (accordionOpen) {
        sibling.style.height = 0;
      } else {
        sibling.style.height =
          sibling.scrollHeight + 14 + "px";
      }
    }
    setAccordionOpen(!accordionOpen);
  };

  return (
    <>
      <div className="accordionDefault">
        <div className="accordion">
          <div
            className="accordion-heading"
            onClick={toggleAccordion}
          >
            <h3 className="title">
              Disclaimer and Other Regulatory Disclosures
            </h3>
            {accordionOpen ? (
              <img
                className="accordion-arrow"
                src={upArrow}
              />
            ) : (
              <img
                className="accordion-arrow"
                src={downArrow}
              />
            )}
          </div>
        </div>
        <div className="accordion-panel">
          {disclaimers.map((disclaimer, index) => (
            <div
              className="row-disclaimer-links"
              key={index}
            >
              <div className="title">
                {disclaimer.title}
              </div>
              <ul className="list">
                {disclaimer.links.map((item, index) => (
                  <li key={index} className="list-item">
                    {item.target ? (
                      <a
                        href={item.link}
                        target={item.target}
                      >
                        {item.title}
                      </a>
                    ) : (
                      <a href={item.link}>{item.title}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
          {[
            phonepeWealth,
            memberId,
            complianceOfficers,
            riskDisclaimer,
            investorDisclaimers,
          ].map((item, index) => (
            <div key={index} className="text">
              {item}
            </div>
          ))}
          <div className="text-bottom">
            {compnayIdNumber}
          </div>
        </div>
      </div>
    </>
  );
};

export default FooterDisclaimers;
